import verhuisdoosImage from "../assets/images/products/Verhuisdoos.jfif";
import steekwagenImage from "../assets/images/products/Steekwagen.jpg";
import palletwagenImage from "../assets/images/products/Palletwagen.png";
import pakdekenImage from "../assets/images/products/Pakdeken.png";
import spanbandImage from "../assets/images/products/Spanband.jpg";
import pianokarImage from "../assets/images/products/Pianokar.jpg";

export const ACCESSORIES_LOCATIONS_MOCK = [
    {
        id: 864,
        name: "Kapper HBakker Sloten",
        partner: "Kapper HBakker",
        distance_km: 2,
        postcode: "1066VX",
        address: "Louwesweg 6, Amsterdam",
        latitude: 52.3438,
        longitude: 4.8062
    },
    {
        id: 813,
        name: "Kapper HBakker West",
        partner: "Kapper HBakker",
        distance_km: 4,
        postcode: "1057CN",
        address: "Hoofdweg 133, Amsterdam",
        latitude: 52.3686,
        longitude: 4.8467
    },
    {
        id: 49,
        name: "Amsterdam Zuidoost",
        partner: "KAV2GO",
        distance_km: 3,
        postcode: "1101AK",
        address: "Klokkenbergweg 17, Amsterdam",
        latitude: 52.3057,
        longitude: 4.9520
    },
    {
        id: 880,
        name: "Diemen",
        partner: "KAV2GO",
        distance_km: 6,
        postcode: "1112NE",
        address: "Verrijn Stuartweg 10, Diemen",
        latitude: 52.3382,
        longitude: 4.9688
    },
    {
        id: 881,
        name: "Amsterdam Noord",
        partner: "Hornbach",
        distance_km: 8,
        postcode: "1024MA",
        address: "Klaprozenweg 75, Amsterdam",
        latitude: 52.4020,
        longitude: 4.9300
    },
    {
        id: 882,
        name: "Amstelveen",
        partner: "Hornbach",
        distance_km: 10,
        postcode: "1181AE",
        address: "Laan Nieuwer-Amstel 2, Amstelveen",
        latitude: 52.3000,
        longitude: 4.8624
    },
    {
        id: 883,
        name: "Utrecht Leidsche Rijn",
        partner: "Hornbach",
        distance_km: 34,
        postcode: "3543AA",
        address: "Middenburcht 11, Utrecht",
        latitude: 52.1030,
        longitude: 5.0334
    },
    {
        id: 884,
        name: "Haarlem",
        partner: "Gamma",
        distance_km: 21,
        postcode: "2031BL",
        address: "A. Hofmanweg 5, Haarlem",
        latitude: 52.3874,
        longitude: 4.6462
    }
];

export const ACCESSORIES_MOCK = [
    {
        id: 1,
        name: "Verhuisdoos",
        partner: "Kapper HBakker",
        category: "Verhuizen",
        icon: "bi bi-box2",
        image: verhuisdoosImage,
        description: "Stevige verhuisdoos met dubbele bodem. Ideaal voor boeken, keukenspullen en kleine apparaten.",
        canRent: false,
        canBuy: true,
        rentPrice: null,
        buyPrice: 3.5,
        deposit: 0,
        locations: ["Kapper HBakker Sloten", "Amsterdam Zuidoost", "Diemen"]
    },
    {
        id: 2,
        name: "Steekwagen",
        partner: "Hornbach",
        category: "Transport",
        icon: "bi bi-truck",
        image: steekwagenImage,
        description: "Compacte steekwagen voor dozen en witgoed. Opvouwbaar en makkelijk mee te nemen.",
        canRent: true,
        canBuy: true,
        rentPrice: 10,
        buyPrice: 79,
        deposit: 50,
        locations: ["Amsterdam Noord", "Kapper HBakker Sloten"]
    },
    {
        id: 3,
        name: "Palletwagen",
        partner: "KAV2GO",
        category: "Transport",
        icon: "bi bi-box-seam",
        image: palletwagenImage,
        description: "Palletwagen voor zwaardere lading. Geschikt voor magazijngebruik en verhuizingen.",
        canRent: true,
        canBuy: false,
        rentPrice: 20,
        buyPrice: null,
        deposit: 120,
        locations: ["Amsterdam Zuidoost", "Utrecht Leidsche Rijn"]
    },
    {
        id: 4,
        name: "Pakdeken",
        partner: "Kapper HBakker",
        category: "Bescherming",
        icon: "bi bi-grid-3x3-gap",
        image: pakdekenImage,
        description: "Dikke beschermdeken voor meubels en apparaten. Voorkomt krassen tijdens vervoer.",
        canRent: true,
        canBuy: true,
        rentPrice: 0.95,
        buyPrice: 12.5,
        deposit: 10,
        locations: ["Kapper HBakker Sloten", "Diemen", "Amstelveen"]
    },
    {
        id: 5,
        name: "Spanband",
        partner: "Gamma",
        category: "Bevestiging",
        icon: "bi bi-link-45deg",
        image: spanbandImage,
        description: "Spanband met ratel voor veilig vastzetten van lading in de bestelbus of aanhanger.",
        canRent: true,
        canBuy: true,
        rentPrice: 1.5,
        buyPrice: 9.95,
        deposit: 5,
        locations: ["Kapper HBakker West", "Amsterdam Zuidoost", "Haarlem"]
    },
    {
        id: 6,
        name: "Pianokar",
        partner: "Hornbach",
        category: "Transport",
        icon: "bi bi-layers",
        image: pianokarImage,
        description: "Professionele pianokar voor zware en brede objecten zoals piano's, kasten en machines.",
        canRent: true,
        canBuy: false,
        rentPrice: 9,
        buyPrice: null,
        deposit: 80,
        locations: ["Amsterdam Noord"]
    }
];
